// extracted by mini-css-extract-plugin
export default {"leftMessageContainer":"styles_leftMessageContainer__wOLce","rightMessageContainer":"styles_rightMessageContainer__SI5w0"};